
/**
 * Returns true if given category is ADR category.
 * @param {string} category 
 * @returns {boolean}
 */
export const isAdrCategory = (category) => {
    if (typeof category !== 'string') {
        return false;
    }
    return category.toLocaleLowerCase().includes('adr');
}
